<template>
  <div class="body">
    <div class="doctor-info">
      <div class="header flex_start_s">
        <div class="doc-head">
          <img :src="doctorinfo.avatar?doctorinfo.avatar:'../../../static/logo.png'" alt />
        </div>
        <div class="doc-content display_flex_start flex_wrap">
          <div class="doc-name">{{doctorinfo.zname}}
            <div class="doc-save"  @click.stop="handleToFav(doctorinfo.id,doctorinfo.type)" v-if="doctorinfo.type && doctorinfo.type != 3"><img :src="doctorinfo.type == 1?img_src:img_src1" alt="" /></div>
            <div class="doc-save" v-if="doctorinfo.type == 3">问诊过</div>
          </div>
          <div class="doc-pos display_flex_start font-65">
            {{doctorinfo.position}}
            <!-- <span class="exper-num" v-if="doctorinfo.is_num>0">问诊{{doctorinfo.is_num}}次</span> -->
          </div>
          <p class="doc-hosp">{{doctorinfo.hospname}}</p>
        </div>
      </div>
      <div class="info-center">
        <div class="doc-label-list display_flex_start" v-if="doctorinfo.label" >
          <div class="doc-label display_flex_start" v-for="(label_item,label_index) in doctorinfo.label_list" v-show="label_index<3" :key="label_index">{{label_item}}</div>
        </div>
      </div>
    </div>
    <div class="doctor-good">
        <div class="doctor-good-title display_flex_start">擅长方向</div>
        <div class="doctor-good-content">{{doctorinfo.goodable}}</div>
    </div>
    <div class="doctor-intro">
        <div class="doctor-intro-title display_flex_start">个人简介</div>
        <div class="doctor-intro-content">{{doctorinfo.introduce}}</div>
    </div>
  </div>
</template>

<script>
import fuzhen_tabs from "../../components/fuzhen_tabs/fuzhen_tabs";
import http from "../../request/http";
export default {
  name: "doctor_content",

  data() {
    return {
      doctorinfo: [],
      docid: "",
      is_more:false,
      img_src:'../../../static/icons/guanzhu_false@3x.png',
      img_src1:'../../../static/icons/guanzhu_true@3x.png'
    };
  },
  components: {
    fuzhen_tabs,
  },
  mounted() {
    let docid = this.$route.query.doctorid;
    this.docid = docid;
    this.docInfo(docid);
  },
  methods: {
    handleToFav(id,type){
      let data = {
        docid:id,
        fan_tag:+type
      }
      http.post('/api/wap/doctor/fan',data).then(res => {
        if(res.errno == 0){
          this.doctorinfo.type = type == 1?2:1;
        }
      })
    },
    docInfo(id) {
      http
        .post("/api/wap/doctor/info", { doctorId: id })
        .then((res) => {
          if (res.data && res.data.length) {
            let data = res.data[0];
            data.is_num = 0;
            data.label_list = [];
            if(data.label){
              data.label_list = data.label.split(',');
            }
            data.is_num = +data.is_graphic + +data.is_phone + +data.is_video;
            this.doctorinfo = data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    routePush(path) {
      this.$router.push(path);
    },
    handleMore(){
      this.is_more = !this.is_more;
    }
  },
};
</script>

<style scoped>
.body {
  padding: 0 0 1rem 0;
  background: #fff;
}
.doctor-info {
  width: 100%;
  height: auto;
  background: rgba(24, 144, 255, 0.01);
  padding: 1.5rem 0.8rem 0rem 1rem;
  position: relative;
}
.doc-save{
  float:right;
  min-width: 1rem;
  height: 0.75rem;
  margin-top:0.2rem;
  font-size: 0.6rem;
  color:rgba(24,144,255,1);
  text-align: right;
}
.doc-save img{
    width: 0.75rem;
    height: 100%;
    vertical-align: top;
}
.header {
  width: 100%;
  margin-bottom: 0.7rem;
}
.doc-content {
  width: calc(100% - 4.4rem);
}
.doc-content .doc-name {
  width: 100%;
  font-size: 1.2rem;
  height: 1.3rem;
  line-height: 1.3rem;
  color: rgba(38, 38, 38, 1);
  margin-bottom: 0.45rem;
}
.doc-content .doc-pos {
  width: 100%;
  height: 1.2rem;
  font-size: 0.7rem;
}
.doc-content .doc-hosp {
  width: 100%;
  height: 1.2rem;
  line-height: 1.2rem;
  font-size: 0.7rem;
  color: rgba(0, 0, 0, 0.5);
}
.doc-head {
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 0.9rem;
}
.doc-head img {
  width: 100%;
  height: 100%;
}
.info-center {
  font-size: 0.6rem;
  display: flex;
  justify-content: space-between;
}
.doc-tabs span {
  display: inline-block;
  padding: 0 0.5rem;
  background: #fa8c16;
  color: #fff;
}
.display_flex_start,.display_flex_between,.flex_start_s {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.display_flex_between{
  justify-content: space-between;
  align-content: flex-start;
}
.flex_wrap {
  flex-wrap: wrap;
}
.flex_start_s{
  align-items: flex-start;
}
.exper-num {
  height: 0.9rem;
  line-height: 0.8rem;
  font-size: 0.6rem;
  padding: 0.05rem 0.2rem;
  color: rgba(24, 144, 255, 1);
  border-radius: 0.15rem;
  margin-left: 0.25rem;
  background-color: rgba(230, 247, 255, 1);
}
.doc-label {
  padding: 0 0.35rem;
  height: 1rem;
  box-sizing: border-box;
  border: 0.05rem solid rgba(250, 140, 22, 0.5);
  border-radius: 0.15rem;
  font-size: 0.6rem;
  color: rgba(250, 140, 22, 1);
}
.doc-label + .doc-label {
  margin-left: 0.4rem;
}
.doctor-good,.doctor-intro{
  width: 100%;
  padding: 1.5rem 1.5rem 0;
  background: #fff;
  box-sizing: border-box;
}
.doctor-good-title,.doctor-intro-title {
  width: 100%;
  height: 1.25rem;
  line-height: 1.25rem;
  font-size: 0.9rem;
  margin-bottom: 0.8rem;
}
.doctor-good-title::before,.doctor-intro-title::before {
  display: block;
  content: "";
  width: 0.15rem;
  height: 0.8rem;
  border-radius: 0.05rem;
  background-color: rgba(24, 144, 255, 1);
  margin-right: 0.25rem;
}
.doctor-good-content,.doctor-intro-content{
    width: 100%;
    line-height: 1.1rem;
    font-size: 0.7rem;
    color:rgba(0, 0, 0, 0.5);
}
</style>



// WEBPACK FOOTER //
// src/pages/doctor/doctor_detail.vue